const POOL_DATA = {
  UserPoolId: 'us-east-2_g5AeGZ658',
  ClientId: '3gfd0h45jbkj5vt2be21kgqrpn'
}

export default POOL_DATA



// WEBPACK FOOTER //
// ./src/cognito-objects/poolData.js